<template>
    <div class="quiz-question-body" :key="currentQuestion.idQuizQuestion">
      <div class="quiz-top">
        <div class="quiz-number">{{currentQuestionIndexBasedOnQuestionsFromThisLevel + 1}}/{{questionsFromThisLevel.length}}</div>
        <div class="quiz-time">
          <div class="quiz-time-bg">
            <div class="quiz-time-fill" :style="{ animationDuration: timeAll + 's'}" :class="{paused: answerSubmitted}"></div>
          </div>
          <span>The time for the answer is running: {{timeLeft}}s left</span>
        </div>
      </div>
      <div class="quiz-question-name" v-html="currentQuestion.question"></div>
      <div class="form-block-radios">
        <label v-for="answer in currentQuestion.Answers" :key="answer.idQuizQuestionAnswer" :class="{
          disabled: answerSubmitted,
          false: answerSubmitted && answerChosen === answer.idQuizQuestionAnswer && !isCorrectAnswer,
          true: answerSubmitted && answerChosen === answer.idQuizQuestionAnswer && isCorrectAnswer,
        }"  @change="answerChosen = answer.idQuizQuestionAnswer">
          <input type="radio" :name="`question-${answer.idQuizQuestion}`" :disabled="answerSubmitted">
          <span>{{answer.answer}}</span>
        </label>
      </div>

      <div class="buttons">
        <button :class="['button--submit', {disabled: !answerChosen}]" v-if="!answerSubmitted" @click="submitAnswer()">Submit answer</button>
        <router-link class="button--submit" v-else-if="nextQuestion" :to="`/${$route.params.companySlug}/quizzes/${$route.params.id}/question/${nextQuestion.idQuizQuestion}`">Next</router-link>
        <router-link class="button--submit" v-else :to="`/${$route.params.companySlug}/quizzes/${$route.params.id}/level/${this.currentQuestion.level + 1}`">Next</router-link>
<!--        <button class="link" @click="openPopup"><span>Leave quiz</span></button>-->
      </div>
    </div>
</template>

<script>
import md5 from "blueimp-md5"
export default {
  name: "QuizQuestion",
  data () {
    return {
      answerChosen: '',
      answerSubmitted: false,
      popupQuizEnd: false,
      timeAll: 30,
      timeLeft: 30,
      loaded: 0,
      time: 0,
    }
  },
  watch: {
    '$route.params.idQuestion': function () {
      this.answerChosen = ''
      this.answerSubmitted = false
      this.popupQuizEnd = false
      this.timeLeft = 30
      this.loaded = Date.now();
      this.runTimer()
    },
    isCorrectAnswer: function () {
        this.time = Date.now() - this.loaded
    },
  },
  computed: {
    isCorrectAnswer() {
      let stringToHash = this.currentQuestion.idQuizQuestion
        + this.answerChosen + this.$store.getters.user.idUser
        + 'EG0q#seo gz4DQ->,P+v2d%n;}lz.XVuQX Dq[$j]5W2M4k-x3E#|2(JeE_ihBY'
      return md5(stringToHash) === this.currentQuestion.correctAnswer;
    },
    answerHash() {
      let stringToHash = this.currentQuestion.idQuizQuestion
          + this.answerChosen + this.$store.getters.user.idUser
          + 'EG0q#seo gz4DQ->,P+v2d%n;}lz.XVuQX Dq[$j]5W2M4k-x3E#|2(JeE_ihBY'.split("").reverse().join("");
      return md5(stringToHash)
    },
    quiz() {
      return this.$store.getters.quiz
    },
    questions() {
      return this.quiz._embedded.Questions
    },
    currentQuestionIndex() {
      return this.questions.findIndex(question => {
        return question.idQuizQuestion === this.$route.params.idQuestion
      })
    },
    currentQuestion() {
      return this.questions[this.currentQuestionIndex]
    },
    currentQuestionIndexBasedOnQuestionsFromThisLevel() {
      return this.questionsFromThisLevel.findIndex(question => {
        return question.idQuizQuestion === this.$route.params.idQuestion
      })
    },
    nextQuestion() {
      if(this.currentQuestionIndex + 1 < this.questions.length && this.questions[this.currentQuestionIndex + 1].level === this.currentQuestion.level) {
        return this.questions[this.currentQuestionIndex + 1]
      }
      return null;
    },
    questionsFromThisLevel() {
      return this.questions.filter(question => {
        return question.level === this.currentQuestion.level
      })
    }
  },
  mounted () {
    this.runTimer()
    this.loaded = Date.now();
  },
  methods: {
    runTimer () {
      let _this = this
      this.timeLeft--
      if (this.timeLeft === 0 || this.answerSubmitted) {
        this.answerSubmitted = true
      } else {
        setTimeout(function () {
          _this.runTimer()
        }, 1000)
      }
    },
    submitAnswer() {
      this.$store.dispatch('setQuizAnswers', {[this.currentQuestion.idQuizQuestion]: {
          correct: Boolean(this.isCorrectAnswer),
          isCorrect: Number(this.isCorrectAnswer),
          time: this.time/1000,
          answer: this.answerHash
        }
      })
      this.answerSubmitted = true
    }
  }
}
</script>
